import { ITutorial } from './types';

export const parseTutorial = (item: ITutorial) => {
    return item;
};
